<div class="store-locator-panel d-flex flex-row flex-wrap justify-content-center align-items-start">
  <div class="flex-100">
    <a button mat-raised-button color="warn" (click)="setCurrentPosition()">
      <mat-icon class="mr-1">my_location</mat-icon>
      <span class="location-button">Take me to my current location</span>
    </a>
  </div>
  <div class="px-1 w-100 mt-2 google-auto flex-100">
    <app-autocomplete (setAddress)="autoComplete($event)" [allowedCountries]="" [allowedCountries]="countries" addressType="(regions)"></app-autocomplete>
  </div>
  <div class="flex-100 px-1 mt-2">
    <span>Find Retailers within {{radius}}km: </span>
    <mat-slider thumbLabel [displayWith]="formatRadius" tickInterval="1" step="1" min="10" max="150" aria-label="radius">
      <input [attr.aria-valuetext]="radius + 'km'" [value]="radius" (valueChange)="onRadiusChange($event)" matSliderThumb>
    </mat-slider>
  </div>
  <div [class]="lat || lng? 'flex-100 flex-md-70 map-container' : 'flex-100 map-container'">
    <div *ngIf="mapInit">
      <google-map id="map" #googleMap [center]="center" [zoom]="zoom" [options]="options" [height]="isMobile? '400px':'700px'" width="100%">
        <deprecated-map-marker-clusterer imagePath='assets/images/map/cluster/m'>
          <map-marker #mapMarker="mapMarker" *ngFor="let marker of markers; let i = index"
                      icon="/assets/images/map/cluster/pin.png"
                      [position]="marker.position"
                      [label]="marker.label"
                      [title]="marker.title"
                      [options]="marker.options"
                      (mapClick)="openWindow(mapMarker, i)">
          </map-marker>
        </deprecated-map-marker-clusterer>
        <map-info-window #mapInfoWindow>
          <div class="info-window">
            <div class="title">{{ selectedLocation?.title }}</div>
            <div class="address">{{selectedLocation?.street}}
              <br>{{selectedLocation?.city}}, {{selectedLocation?.state}}, {{selectedLocation?.postalCode}}
            </div>
            <div class="phone">{{selectedLocation?.phone}}</div>
            <div class="email">{{selectedLocation?.email}}</div>
            <div class="web" *ngIf="selectedLocation?.website">
              <a href="{{selectedLocation?.website}}" target="_blank" rel="noreferrer" (click)="dealerWebsiteClick(selectedLocation)">Visit Website&nbsp;&gt;</a>
            </div>
          </div>
        </map-info-window>
      </google-map>
    </div>
  </div>
  <div *ngIf="lat || lng" class="flex-100 flex-md-30 dealer-list">
    <div *ngFor="let location of locationList, let i = index">
      <mat-card *ngIf="i == 0 || location.distance < radius " [class]="location.title === selectedLocation?.title? 'store active-store': 'store'">
        <a (click)="showDealer(location)">
          <div class="title">{{ location.title }}</div>
          <div class="address">{{location.street}}
            <br>{{location.city}}, {{location.state}}, {{location.postalCode}}
          </div>
          <div class="phone">{{location.phone}}</div>
          <div class="email">{{location.email}}</div>
          <div *ngIf="location?.website" class="web">
            <a href="{{location.website}}" target="_blank" rel="noreferrer" (click)="dealerWebsiteClick(location)">Visit Website</a>
          </div>
        </a>
      </mat-card>
    </div>
  </div>
</div>
